import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=72ed4071&scoped=true&"
import script from "./Orders.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Orders.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=72ed4071&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed4071",
  null
  
)

export default component.exports